import { render, staticRenderFns } from "./NetErrorPage.vue?vue&type=template&id=3870cf45&"
import script from "./NetErrorPage.vue?vue&type=script&lang=ts&"
export * from "./NetErrorPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports